import React from 'react'
import { CheckCircleOutline } from '@mui/icons-material'
import * as S from './styles'

interface TotalPassMetricInfoProps {
  total: number
  totalPassCount: number
  visible?: boolean
}

const buildLabel = (total: number, totalPassCount: number): string => {
  const locale = window.localStorage.getItem('@StarBem:lang')

  if (locale === 'en') {
    const noun = total === 1 ? 'appointment' : 'appointments'
    const verb = totalPassCount === 1 ? 'is' : 'are'
    return `Of the ${total} ${noun}, ${totalPassCount} ${verb} Start`
  }

  const prefix = total === 1 ? 'De' : 'Dos'
  const noun = total === 1 ? 'atendimento' : 'atendimentos'
  const verb = totalPassCount === 1 ? 'é' : 'são'
  return `${prefix} ${total} ${noun}, ${totalPassCount} ${verb} Start`
}

const TotalPassMetricInfo: React.FC<TotalPassMetricInfoProps> = ({
  total,
  totalPassCount,
  visible = true,
}) => {
  if (!visible || total === 0 || totalPassCount === 0) return null

  return (
    <S.Container>
      <S.IconWrapper>
        <CheckCircleOutline className="icon" />
      </S.IconWrapper>
      <span className="label">{buildLabel(total, totalPassCount)}</span>
    </S.Container>
  )
}

export default TotalPassMetricInfo
